// extracted by mini-css-extract-plugin
export default {"surveyTitle":"YkQpohzyDTJ8WaL4"};